<div class="header-container">
  @if (backButton()) {
    <fa-icon
      class="back-button"
      (click)="backButtonClicked.emit()"
      [icon]="faChevronLeft"
    />
  }
  @if (logo()) {
    <div class="logo" data-testid="logo">
      <img alt="logo" src="/assets/new-ui/img/profile.svg" />
    </div>
  }
  <div class="title-container">
    <h4 data-testid="title">{{ title() }}</h4>
    @if (subTitle()) {
      <p data-testid="subtitle">
        {{ subTitle() }}
      </p>
    }
  </div>
</div>
<ng-content />
